/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ui-users-page-grid .ui-grid-cell[data-property=userName] .ui-grid-cell-content{height:100%;display:flex;align-items:center}.ui-users-page-grid .ui-grid-cell[data-property=userName] .ui-grid-cell-content mat-icon{margin-right:5px;min-width:24px}"];
export { styles as styles };
